import React, { useState } from 'react';
import { Box, Label, Wrapper } from './style';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  type?: string;
  value?: string | number;
  prepend?: React.ReactNode;
  inputId?: string;
  wrapperClass?: string;
  boxClass?: string;
}

const Input = ({ label, type, value, prepend, inputId, ...props }: InputProps) => {
  const [hidePassword, setHidePassword] = useState(type === 'password');

  const handleTogglePassword = () => {
    setHidePassword(prev => !prev);
  };

  return (
    <Wrapper className={props.wrapperClass}>
      {label && <Label htmlFor={inputId}>{label}</Label>}
      {/* @ts-ignore */}
      <Box type={type} className={props.boxClass}>
        {prepend && prepend}

        <input
          id={inputId}
          value={value}
          name={props.name}
          type={type === 'password' && !hidePassword ? 'text' : type}
          {...props}
        />

        {type === 'password' && (
          <button type="button" onClick={handleTogglePassword}>
            {!hidePassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </button>
        )}
      </Box>
    </Wrapper>
  );
};

export default Input;
